import { ForemanArea } from './ForemanArea';
import { ContractArea } from './ContractArea';

export enum AssetStatus {
  Active = 'Active',
  Disabled = 'Disabled'
}

export interface Asset {
  id: number;
  name: string;
  description?: string;
  assetType: AssetType;
  assetNumber: string;
  subtype?: string;
  startLatitude?: number;
  startLongitude?: number;
  endLatitude?: number;
  endLongitude?: number;
  highwayUnique?: string;
  numberedRoad?: boolean;
  parentAsset?: string;
  contractAreaId?: number;
  contractArea?: ContractArea;
  taskLocations?: any[]; // Using any[] temporarily to avoid circular dependency
  // New columns for distance calculation
  summerClass?: string;
  winterClass?: string;
  length?: number; // Length in kilometers
  status?: AssetStatus;
}

export interface AssetHistoryDetail {
  field: string;
  oldValue: string | number | null;
  newValue: string | number | null;
}

export interface AssetHistoryEntry {
  id: number;
  assetId: number;
  stage: string;
  summary: string;
  details?: AssetHistoryDetail[] | null;
  userId?: number | null;
  createdAt: string;
  user?: { id: number; name: string; lastName: string } | null;
}

export enum AssetType {
  road = 'road',
  culvert = 'culvert',
  sign = 'sign',
  cattleguard = 'cattleguard',
  restarea = 'restarea',
  structures = 'structure'
}

